import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import NotificationsOffOutlinedIcon from '@material-ui/icons/NotificationsOffOutlined'
import { useState } from 'react'

const MS = {
  hour: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  week: 7 * 24 * 60 * 60 * 1000,
  month: 30 * 24 * 60 * 60 * 1000,
}

const INDEFINITE = 'indefinite'

const MUTE_DURATION_OPTIONS = [
  { label: '1 hour', value: MS.hour },
  { label: '1 day', value: MS.day },
  { label: '1 week', value: MS.week },
  { label: '1 month', value: MS.month },
  { label: '6 months', value: 6 * MS.month },
  { label: 'Until unmuted', value: INDEFINITE },
]

function MuteChannelDialog({ open, setOpen, channel, onSuccess }) {
  const [selectedDuration, setSelectedDuration] = useState(
    MUTE_DURATION_OPTIONS[0].value,
  )

  const handleConfirm = async () => {
    const options =
      selectedDuration !== INDEFINITE
        ? { expiration: selectedDuration }
        : undefined
    await channel.mute(options)
    onSuccess()
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Mute Conversation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Stop receiving notifications for this conversation for:
        </DialogContentText>
        <FormControl variant="outlined" fullWidth style={{ marginTop: '16px' }}>
          <InputLabel id="mute-duration-label">Mute for</InputLabel>
          <Select
            labelId="mute-duration-label"
            value={selectedDuration}
            onChange={e => setSelectedDuration(e.target.value)}
            label="Mute for"
          >
            {MUTE_DURATION_OPTIONS.map(option => (
              <MenuItem key={option.label} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleConfirm}
          startIcon={<NotificationsOffOutlinedIcon />}
        >
          Mute
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MuteChannelDialog
